module.exports = __webpack_public_path__ + "static/media/bim-1.424b34f9.jpg";